var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessReject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 86,
  x: 120.009,
  y: 45.009,
  fill: "#223B90",
  rx: 12
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 100,
  x: 114,
  y: 38,
  fill: "#3863F0",
  rx: 12
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 45.14,
  height: 8.766,
  x: 124,
  y: 91,
  fill: "#223B90",
  rx: 4.383
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 30.78,
  height: 8.766,
  x: 124,
  y: 107.286,
  fill: "#223B90",
  rx: 4.383
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M136.642 68.707a5.853 5.853 0 0 0 5.853-5.853 5.853 5.853 0 1 0-11.707 0 5.854 5.854 0 0 0 5.854 5.853M136.642 71.634c-5.865 0-10.642 3.934-10.642 8.78a.58.58 0 0 0 .585.586h20.114a.58.58 0 0 0 .585-.585c0-4.847-4.777-8.78-10.642-8.78"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 191.5,
  cy: 127.5,
  r: 23.5,
  fill: "#F23015"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M200.803 115.208a3.51 3.51 0 0 0-4.891.86l-.001.002-4.87 6.941-6.957-4.871a3.51 3.51 0 0 0-4.891.863 3.51 3.51 0 0 0 .862 4.891l6.955 4.87-4.87 6.955a3.51 3.51 0 0 0 .863 4.891 3.51 3.51 0 0 0 4.891-.862l4.87-6.955 6.955 4.87a3.51 3.51 0 0 0 4.891-.863 3.51 3.51 0 0 0-.862-4.891l-6.955-4.87 4.87-6.955a3.52 3.52 0 0 0-.86-4.876m-2.37 1.406a1.5 1.5 0 0 0-.884.603l-6.019 8.578 6.02-8.578c.22-.314.537-.519.883-.603m3.656 19.642a1.5 1.5 0 0 1-1.223-.232l-8.593-6.016 8.593 6.017c.371.259.816.33 1.223.231m-16.716 2.948a1.5 1.5 0 0 1-1.223-.232 1.51 1.51 0 0 1-.371-2.106l6.016-8.593-8.592-6.017a1.51 1.51 0 1 0-.001 0l8.593 6.017-6.017 8.593a1.51 1.51 0 0 0 .372 2.106c.371.26.816.33 1.223.232",
  clipRule: "evenodd"
})));
export default SvgProcessReject;